<template>
      <div class="wrapper wrapper-content">
        <div class="container-fluid">

<div class="">

  <div class="row">
    <div class="col-lg-12">
      <div class="ibox float-e-margins">
        <div class="ibox-title">
            <h5>
            <router-link :to="{name: 'numberset'}" class="text-primary-new">เลขชุด</router-link> / สร้างเลขชุด
            </h5>
        </div>

        <div class="ibox-content">

          <div class="">
            <form id="insert_form" @submit.prevent="processInsertNumber" class="m-t form-horizontal fv-form fv-form-bootstrap">
            <div class="form-group has-feedback">
              <label class="col-lg-2 control-label">ชื่อชุดตัวเลข</label>
              <div class="col-lg-10">
                <input type="text" name="un_name" class="form-control" placeholder="ระบุชื่อชุดตัวเลข" id="un_name" v-model="un_name">
              </div>
            </div>

            <div class="form-group has-feedback" v-for="(item, index) in un_number_set" :key="'un_number_set-' + index">

              <label class="col-xs-2 col-lg-2 control-label">
                <a class="btn btn-danger btn-remove-number-sets" @click="deleteNumberItem(index)" ><i class="fa fa-trash"></i></a>
              </label>
              <div class="col-xs-10 col-lg-6">
                <select class="form-control dropdown-numberset" @change="assignValue(index, 'bettype_id', $event)" v-model="item.bettype_id">
                    <option value="4" >สามตัวบน</option>
                    <option value="1" >สามตัวโต๊ด</option>
                    <option value="6" >สองตัวบน</option>
                    <option value="7">สองตัวล่าง</option>
                    <option value="8" >วิ่งบน</option>
                    <option value="9" >วิ่งล่าง</option>
                </select>
              </div>

              <div class="col-xs-12 col-lg-4 row-problem">
                <div class="input-group">
                  <span class="input-group-addon">ใส่ตัวเลข <strong class="text-danger">{{ bettypeMaxLengthMapping[item.bettype_id] }}</strong> ตัว</span>
                  <input name="un_number" class="form-control" placeholder="ระบุตัวเลข" :maxlength="bettypeMaxLengthMapping[item.bettype_id]" @change="assignValue(index, 'number', $event, bettypeMaxLengthMapping[item.bettype_id])"  @keypress="onlyNumber" v-model="item.number">
                </div>
              </div>

            </div>

            <div class="form-group group-btn-add">
              <label class="col-lg-2 control-label"></label>
              <div class="col-lg-10">
                <button class="btn btn-primary btn-add-number-set" @click="addNumberItem" type="button"><i class="fa fa-plus"></i> เพิ่มชุดตัวเลข</button>
              </div>
            </div>

            <div class="form-group">
              <div class="col-lg-offset-2 col-lg-10">
                <button class="btn btn-primary" type="submit" :disabled="!isValid">บันทึก</button>
                <router-link :to="{name: 'numberset'}" class="btn btn-link "> ยกเลิก</router-link>
              </div>
            </div>
            </form>
          </div>



        </div> <!-- /.ibox-content -->
      </div> <!-- /.ibox -->
    </div> <!-- /.col-lg-12 -->
  </div> <!-- /.row -->

            </div>

        </div>
      </div><!-- /#page-wrapper -->
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'

export default {
    name: 'numberset',
    data () {
        return {
            query: {
                sort: '',
                order: 'desc',
                page: 0,
                limit: 5,
                type: 'lotto',
            },
            orderhead: [],
            lastUpdate: new Date().toLocaleString(),
            tableProps: {
                border: true,
                stripe: true,
                defaultSort: {
                    prop: 'created_at',
                    order: 'descending'
                },
            },
            un_name: '',
            un_number_set: [],

            // bettypeTextMapping: {
            //     threetop: 'สามตัวบน',
            //     threemix: 'สามตัวโต๊ด',
            //     twotop: 'สองตัวบน',
            //     twodown: 'สองตัวล่าง',
            //     runtop: 'วิ่งบน',
            //     rundown: 'วิ่งล่าง',
            // },

            // bettypeCodeMapping: {
            //     threetop: '4',
            //     threemix: '1',
            //     twotop: '6',
            //     twodown: '7',
            //     runtop: '8',
            //     rundown: '9',
            // },

            bettypeMaxLengthMapping: {
                '4': 3,
                '1': 3,
                '6': 2,
                '7': 2,
                '8': 1,
                '9': 1,
            },

            isValid: true,

        }
    },
    computed: {
        ...mapState({
            user: state => state.user.user,
        })
    },
    methods: {

        async processInsertNumber () {

            //console.log('processInsertNumber un_number_set', this.un_number_set)

            if (!this.un_name) {
                this.$toasted.error('กรุณาระบุชื่อเลขชุด')
                return
            }

            if ( this.un_number_set.length > 0 ) {

                for (let i = 0; i < this.un_number_set.length; i++) {
                    let item_line = this.un_number_set[i]
                    let max_length = this.bettypeMaxLengthMapping[ item_line.bettype_id ]

                    if ( item_line.number.length !== max_length ) {
                        this.$toasted.error('กรุณาระบุจำนวนของตัวเลขให้ถูกต้อง')
                        return
                    }
                }

            }
            else {
                this.$toasted.error('กรุณาเพิ่มชุดตัวเลขอย่างน้อย 1 ชุด')
                return
            }
            
            //remove duplicated number set
            const number_set = this.un_number_set.filter(
                (item, index, self) =>
                    index === self.findIndex((t) => (
                        t.bettype_id === item.bettype_id && t.number === item.number
                    ))
            )
            //console.log('processInsertNumber uniq', number_set)

            let usernumberData = {
                user_id: this.user.id,
                name: this.un_name,
                item: number_set,
            }
            //console.log('usernumberData', usernumberData)

            try {
                await this.$store.dispatch('usernumber/createUsernumber', usernumberData)
                this.$toasted.success('สร้างเลขชุดเรียบร้อย.')

                this.un_name = ''
                this.un_number_set = []

                this.$router.push({name: 'numberset',})


            } catch (error) {
                //console.log('Error response', error.response)
                let error_msg = 'There was an error connecting to the server.'
                let response = error.response.data
                if ( response ) {
                    error_msg = response.message
                }

                this.$toasted.error(error_msg)
                this.$router.go(0)
            }
        },

        onlyNumber ($event) {
            //console.log($event.keyCode) //keyCodes value
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which)
            if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
                $event.preventDefault()
            }
        },

        addNumberItem () {
            //console.log('addNumberItem', this.un_number_set)
            this.un_number_set.push({ bettype_id: 4, number: '' })
        },

        deleteNumberItem (index) {
            this.$delete(this.un_number_set, index)
        },


        assignValue(index, type, event, maxlength) {
            if (event) event.preventDefault()

            let new_value = event.target.value
            this.un_number_set[index][type] = new_value

            //console.log('assignValue', this.un_number_set)
        },

        formatDate (value) {
            if (value) {
                let date = new Date(value)
                return moment(date).format('DD/MM/YYYY HH:mm:ss')
            }
        },
        getNow () {
            let now = new Date()
            this.lastUpdate = moment(now).format('DD/MM/YYYY HH:mm:ss')
        },


    },

    mounted () {
    },
    created () {
    },
    destroyed () {
    }
}
</script>

<style lang="sass" scoped>
</style>
